module.exports = __webpack_public_path__ + "media/images/navbar_dogs-e7e3f021989ebc990b66d65d84c3a5d2.png";